export default "__VITE_ASSET__a2be67c4__"